import { render, staticRenderFns } from "./PeekaiNudge.vue?vue&type=template&id=d7fb0428"
import script from "./PeekaiNudge.vue?vue&type=script&lang=js"
export * from "./PeekaiNudge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports